(function () {
  'use strict';

  function syncStickyPrice() {
    const activeOption = document.querySelector(
      '.moonbundle-option-active .moonbundle-option-single-price'
    );
    if (!activeOption) return;

    const priceText = activeOption.textContent.trim();
    if (!priceText) return;

    const stickyPrice = document.querySelector(
      '.sticky-add-to-cart__price .price__regular .price'
    );
    if (!stickyPrice) return;

    stickyPrice.textContent = priceText;
  }

  function syncStickyTitle() {
    const activeTitle = document.querySelector(
      '.moonbundle-option-active .moonbundle-option-title span'
    );
    if (!activeTitle) return;

    const titleText = activeTitle.textContent.trim();
    if (!titleText) return;

    // Find or create the bundle label element
    let bundleLabel = document.querySelector('.sticky-bundle-label');

    if (!bundleLabel) {
      bundleLabel = document.createElement('span');
      bundleLabel.className = 'sticky-bundle-label';
      bundleLabel.style.cssText = 'display:block; font-size:0.85em; opacity:0.75;';

      const stickyTitle = document.querySelector('.sticky-add-to-cart__title');
      if (!stickyTitle) return;

      stickyTitle.insertAdjacentElement('afterend', bundleLabel);
    }

    bundleLabel.textContent = titleText;
  }

  function syncAll() {
    syncStickyPrice();
    syncStickyTitle();
  }

  function initMoonBundleSync() {
    const moonBundle =
      document.querySelector('moonbundle-component') ||
      document.querySelector('.moonbundle-options-horizontal');

    if (!moonBundle) {
      setTimeout(initMoonBundleSync, 500);
      return;
    }

    syncAll();

    const observer = new MutationObserver(function () {
      syncAll();
    });

    observer.observe(moonBundle, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class'],
    });

    document.querySelectorAll('.moonbundle-option-wrapper').forEach(function (el) {
      el.addEventListener('click', function () {
        setTimeout(syncAll, 150);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMoonBundleSync);
  } else {
    initMoonBundleSync();
  }
})();